import { useEffect, useState } from "react"

export const useStickyNavigation = (mainMenuHeight, isAlwaysSticky = false) => {
  const [showStickyNav, setShowStickyNav] = useState(false)
  const [isSticky, setIsSticky] = useState(false)
  const [lastScrollY, setLastScrollY] = useState(0)
  const [scrollDelta, setScrollDelta] = useState(0)
  const [hasHiddenOnce, setHasHiddenOnce] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      const isScrollingUp = scrollY < lastScrollY
      const hasScrolledPastThreshold = scrollY > window.innerHeight * 0.25
      const hasScrolledPastMainMenu =
        scrollY > mainMenuHeight + (isAlwaysSticky ? 0 : 120)
      if (!isAlwaysSticky) {
        if (!isScrollingUp) {
          setScrollDelta(prev => prev + (scrollY - lastScrollY))
        } else {
          setScrollDelta(0)
        }
      }

      if (hasScrolledPastMainMenu) {
        setIsSticky(true)
      } else {
        setIsSticky(false)
      }
      if (isAlwaysSticky) {
        setShowStickyNav(true)
      }

      if (scrollDelta > 100 && !isAlwaysSticky) {
        setShowStickyNav(false)
        setHasHiddenOnce(true)
      }

      if (
        isScrollingUp &&
        hasScrolledPastThreshold &&
        hasHiddenOnce &&
        !isAlwaysSticky
      ) {
        setShowStickyNav(true)
      }

      setLastScrollY(scrollY)
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [lastScrollY, mainMenuHeight, scrollDelta, hasHiddenOnce])

  return { showStickyNav, isSticky }
}
